export default "__VITE_ASSET__1bab07e5__"